<script setup lang="ts">
import {RouterLink, useRouter} from "vue-router";
import {Button, Icon} from "@/Components/Library";

type Props = {
    title?: string;
    preTitle?: string;
    subtitle?: string;
    icon?: string;
    breadcrumbs?: Array<{text: string; link?: string}>;
};

const props = withDefaults(defineProps<Props>(), {
    title: "Page heading",
    preTitle: "",
    subtitle: "",
    breadcrumbs: () => [],
});
const router = useRouter();
</script>
<template>
    <div class="mb--4">
        <slot name="breadcrumbs">
            <div v-if="breadcrumbs.length" class="mb-1 flex items-center text-sm font-bold uppercase">
                <template v-for="(crumb, i) in breadcrumbs">
                    <RouterLink :to="crumb.link" v-if="crumb.link" class="hover:underline">{{ crumb.text }}</RouterLink>
                    <span v-else>{{ crumb.text }}</span>
                    <span class="mx-1" v-if="preTitle || i + 1 < breadcrumbs.length">/</span>
                </template>
                <span v-if="preTitle">{{ preTitle }}</span>
            </div>
        </slot>
        <h4 v-if="preTitle && !breadcrumbs.length" class="mb-1 text-sm font-bold uppercase">
            {{ preTitle }}
        </h4>
        <div class="flex items-center">
            <div class="flex items-center">
                <Button
                    @click="router.back()"
                    :icon="{icon: 'mingcute:arrow-left-fill', width: 24}"
                    rounded
                    class="!py-1.5 !pr-2 !ring-0"
                />
                <Icon v-if="icon" :icon="icon" width="30" height="30" class="mr-2 mt-1 text-askr-green-500" />
                <div>
                    <slot name="heading">
                        <h3 class="font-display py-1 text-2xl font-bold">
                            {{ title }}
                        </h3>
                    </slot>
                    <slot name="subtitle">
                        <p v-if="subtitle" class="mt-2 text-lg">
                            {{ subtitle }}
                        </p>
                    </slot>
                </div>
            </div>
            <div class="flex grow py-0.5 pl-1" v-if="!!$slots.default">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
